import { Injectable } from '@jack-henry/frontend-utils/di';
import { NavigationService } from '@treasury/core/navigation';
import { CompanyUserSummary } from '@treasury/domain/company/user/entities';
import { RowActionCommand, RowActionCommandResult } from '../base.cmd';
import { CompanyUserActionType } from './user-actions.types';

@Injectable()
export class ConsumerViewUserCommand implements RowActionCommand<
    CompanyUserSummary,
    CompanyUserActionType
> {
    constructor(private readonly navigationService: NavigationService) {}

    public command(): RowActionCommandResult<CompanyUserSummary, CompanyUserActionType> {
        return {
            type: CompanyUserActionType.View,
            title: 'View User',
            action: (user: CompanyUserSummary) => this.execute(user),
        };
    }

    private execute(user: CompanyUserSummary) {
        if (!user.id) {
            throw new Error('User not found');
        }
        this.navigationService.navigate(`/admin/users/${user.id}`);
    }
}
